module.exports = __webpack_public_path__ + "static/media/logos-print-edifeci.58841671.jpg";